export default "__VITE_ASSET__CxkbxYsS__"